import React from 'react';

interface PageHeroProps {
  label: string;
  title: string;
  titleAccent?: string;
  description: string;
}

export const PageHero: React.FC<PageHeroProps> = ({
  label,
  title,
  titleAccent,
  description,
}) => {
  return (
    <section className="relative pt-32 pb-20 overflow-hidden">
      {/* Hero glow effect */}
      <div className="absolute top-20 left-1/2 -translate-x-1/2 w-[800px] h-[400px] pointer-events-none">
        <div 
          className="absolute inset-0 opacity-[0.08] blur-[100px]"
          style={{
            background: 'radial-gradient(ellipse at center, hsl(190 100% 50%) 0%, transparent 70%)',
          }}
        />
      </div>
      
      <div className="container mx-auto px-6 relative">
        <div className="max-w-4xl mx-auto text-center">
          {/* Micro label with pill styling */}
          <div className="inline-flex items-center px-4 py-1.5 rounded-full border border-primary/20 bg-primary/5 mb-8">
            <span className="text-[11px] font-semibold tracking-[0.12em] uppercase text-primary">
              {label}
            </span>
          </div>
          
          {/* Title with optional accent */}
          <h1 
            className="font-display font-bold text-foreground mb-6 animate-fade-in"
            style={{ 
              fontSize: 'clamp(40px, 8vw, 64px)', 
              lineHeight: '1.1', 
              letterSpacing: '-0.02em' 
            }}
          >
            {title}
            {titleAccent && (
              <>
                <br />
                <span className="bg-gradient-to-r from-primary via-primary/80 to-primary bg-clip-text text-transparent">
                  {titleAccent}
                </span>
              </>
            )}
          </h1>
          
          {/* Description */}
          <p 
            className="text-muted-foreground max-w-2xl mx-auto animate-fade-in"
            style={{ 
              fontSize: 'clamp(16px, 2vw, 20px)', 
              lineHeight: '1.6',
              animationDelay: '100ms' 
            }}
          >
            {description}
          </p>
        </div>
      </div>
    </section>
  );
};
